var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.to ? 'router-link' : 'button',_vm._g({tag:"component",class:[
    'font-semibold px-2 rounded-md',
    ("bg-" + _vm.background),
    ("text-" + (_vm.background==='light'
      ? _vm.color==='light'
        ? 'dark shadow-md'
        : (_vm.color + " shadow-md")
      : _vm.color)),
    _vm.background==='light'
      ? "hover:bg-light-d-6"
      : _vm.background==='dark'
        ? "hover:bg-dark-l-10"
        : ("hover:bg-" + _vm.background + "-d-2"),
    _vm.large ? '' : 'w-full md:min-w-32 text-base py-2.5',
    {
      'py-4 text-lg w-full md:min-w-40': _vm.large,
      'bg-opacity-30': _vm.transparent
    }
  ],attrs:{"to":_vm.to,"type":_vm.type}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }